import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink
} from "firebase/auth";
import { auth } from "../components/firebase";

const KEY = "pp_emailForSignIn";

// 1) если задано — всегда шлём письмо на прод (даже из localhost)
function getRedirectBase() {
  const forced = process.env.REACT_APP_EMAIL_REDIRECT_BASE;
  if (forced) return forced.replace(/\/+$/, ""); // убрать слэш в конце
  return window.location.origin;
}

export async function sendMagicLink(email) {
  const base = getRedirectBase();

  const actionCodeSettings = {
    url: `${base}/finish-email-login`, // <-- твой существующий route
    handleCodeInApp: true
  };

  await sendSignInLinkToEmail(auth, email, actionCodeSettings);
  window.localStorage.setItem(KEY, email);
  window.localStorage.setItem("pp_auth_method", "email");
}

// ✅ теперь можно завершать вход даже если email нет в localStorage (введём вручную)
export async function finishMagicLinkLogin(emailOverride) {
  const href = window.location.href;
  if (!isSignInWithEmailLink(auth, href)) return { ok: false, reason: "not_email_link" };

  const email = (emailOverride || window.localStorage.getItem(KEY) || "").trim().toLowerCase();
  if (!email) return { ok: false, reason: "missing_email" };

  const cred = await signInWithEmailLink(auth, email, href);

  window.localStorage.removeItem(KEY);
  window.localStorage.setItem("pp_auth_method", "email");

  return { ok: true, user: cred.user };
}
